import {jsx as _jsx} from "react/jsx-runtime";
import {cn} from '../cn'

const Widgets = ({className, ...props}) => (
  _jsx('svg', {
    viewBox: "0 0 24 24"   ,
    'aria-hidden': "true",
    focusable: "false",
    ...props,
    className: cn(
      'inline-block h-[1em] w-[1em] shrink-0 select-none fill-current text-[24px]',
      className
    ),
 children: 
    _jsx('path', { d: "M13 13v8h8v-8zM3 21h8v-8H3zM3 3v8h8V3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66z"      ,} )
  })
)

export default Widgets
